module.exports = __webpack_public_path__ + "static/img/man.e81ef54.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/man.png
// module id = JBOh
// module chunks = 2